import type { TRuleWithTheme } from 'styles/theme';

export const tableContainer: TRuleWithTheme = () => ({
    '& .ant-table-cell': {
        paddingLeft: '0px !important',
        paddingRight: '0px !important',
        paddingTop: '0px !important',
        paddingBottom: '0px !important',
    },
    '& Table': {
        borderCollapse: 'separate',
        borderSpacing: '0 1rem',
    },
    '& .ant-table': {
        backgroundColor: 'transparent',
    },
    '& .ant-card': {
        backgroundColor: 'transparent',
    },
    '& tr::after': {
        height: '0px !important',
    },
});
